import { Fragment, useEffect, useState } from "react";
import moment from "moment";

import { fetchAuthorizationURL } from "../../PaystackProcessor/api-handler";
import HexLoader from "../../../HexLoader";
import { handleError, minutesFrom } from "../../../../utils/common-utils";
import axios from "../../../../utils/axios";

let intervalRef = null;
let initialTime = null;

const CheckoutPrompt = (props) => {
  const [loading, setLoading] = useState(false);
  const [checkoutDetails, setCheckoutDetails] = useState(null);

  const {
    paymentStatusURL,
    onPaymentFailure,
    onPaymentSuccessful,
    checkoutAPIProps,
    referenceKey,
    authorizationURLKey,
    apiKey,
    checkoutUrl,
    hidePrompt,
  } = props;

  useEffect(() => {
    clearIntervalRef();
    
    if (!initialTime) {
      initialTime = moment();
    }
    getAuthorizationURL();
    return () => {
      clearIntervalRef();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (checkoutDetails) {
      openPage();
      checkPaymentStatus();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails]);

  const getAuthorizationURL = () => {
    setLoading(true);

    fetchAuthorizationURL(checkoutUrl, checkoutAPIProps)
      .then(({ data }) => {
        const details = apiKey ? data[apiKey] : data;

        setCheckoutDetails({
          checkoutUrl: details[authorizationURLKey],
          reference: details[referenceKey],
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        const message = handleError(error);
        hidePrompt();
        onPaymentFailure(message);
      });
  };

  const clearIntervalRef = () => {
    if (intervalRef) {
      clearInterval(intervalRef);
      intervalRef = null;
    }

    if (initialTime) initialTime = null;

    checkoutDetails && setCheckoutDetails(null);
  };

  const openPage = () => {
    popupWindow(window, 900, 700);
  };

  const popupWindow = (win, w, h) => {
    const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
    const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;

    const { checkoutUrl } = checkoutDetails;

    return window.open(
      checkoutUrl,
      "",
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}, self=yes`
    );
  };

  const checkPaymentStatus = async () => {
    if (!intervalRef) {
      intervalRef = setInterval(() => {
        fetchPaymentStatus()
          .then(({ id, transactionStatus }) => {
            window.close();

            if ("PENDING_CLAIM" === transactionStatus) {
              hidePrompt();
              onPaymentSuccessful(id);
            } else {
              hidePrompt();
              onPaymentFailure("Payment Failed");
            }

            clearIntervalRef();
          })
          .catch(() => {
            const minutesPassed = minutesFrom(initialTime);

            if (minutesPassed >= 10) {
              hidePrompt();
              onPaymentFailure("Payment Failed");
              clearIntervalRef();
            }
          });
      }, 3000);
    }
  };

  const fetchPaymentStatus = async () => {
    const { reference } = checkoutDetails;
    const { data } = await axios.get(`${paymentStatusURL}${reference}`);

    const { id, status } = data;

    return {
      id,
      transactionStatus: status,
    };
  };

  if (loading) return <HexLoader />;

  return <Fragment></Fragment>;
};

export default CheckoutPrompt;
